import {FormControl, FormHelperText, FormLabel, Radio, RadioGroup} from "@mui/joy";
import {Controller, useFormContext} from "react-hook-form";
import React from "react";

export function FormRadioButtons({ name, label, options, helperText }) {
  const form = useFormContext();
  const errors = form.formState.errors;

  return (
    <FormControl error={!!errors[name]}>
      <FormLabel>{label}</FormLabel>      
      {helperText && <FormHelperText sx={{ mb: 1.5 }}>{helperText}</FormHelperText>}
      <Controller
        name={name}
        control={form.control}
        render={({field: {ref, value, onChange, onBlur}, fieldState: {error}}) => {
          return (
            <RadioGroup ref={ref} value={value} onChange={onChange} onBlur={onBlur} error={error == null ? 'false' : 'true'}>
              {options.map((option, index) => (<React.Fragment key={option.value}>
                <Radio value={option.value} label={option.label} sx={{ pb: option.description ? 2.5 : 0 }} slotProps={option.description ? { input: { 'aria-describedby': `${option.value}-helper-text` } } : {}} />
                {option.description && <FormHelperText id={`${option.value}-helper-text`} sx={{ mt: -2, mb: index === options.length - 1 ? 0 : 2.5 }}>{option.description}</FormHelperText>}
              </React.Fragment>))}
            </RadioGroup>
          );
        }}
      />      
      {errors[name] && <FormHelperText>{errors[name].message}</FormHelperText>}
    </FormControl>
  );
}